import React, { useState } from "react";
import { TiMediaPlay } from "react-icons/ti"; // Import de l'icône play depuis react-icons

const VideoGallery = () => {
  const videos = [
    {
      src: "https://player.vimeo.com/video/1022932659",
      thumbnail: "/img/portfolio/video-img/vimeo1_compression.jpg",
      title: "Clarins - Royal Jump",
    },
    {
      src: "https://player.vimeo.com/video/1022934398",
      thumbnail: "/img/portfolio/video-img/vimeo2_compression.jpg",
      title: "Action contre la Faim",
    },
    {
      src: "https://player.vimeo.com/video/1023538548",
      thumbnail: "/img/portfolio/video-img/vimeo3_compression.jpg",
      title: "Soundslike",
    },
    {
      src: "https://player.vimeo.com/video/1022941777",
      thumbnail: "/img/portfolio/video-img/vimeo4_compression.jpg",
      title: "Backmarket",
    },
    {
      src: "https://player.vimeo.com/video/1025608891",
      thumbnail: "/img/portfolio/video-img/vimeo5_compression.jpg",
      title: "Sorayama",
    },
    {
      src: "https://player.vimeo.com/video/1022973671",
      thumbnail: "/img/portfolio/video-img/vimeo6_compression.jpg",
      title: "Bang Hai Ja",
    },
    {
      src: "https://player.vimeo.com/video/1022939321",
      thumbnail: "/img/portfolio/video-img/vimeo7_compression.jpg",
      title: "Vidéo Formation Harmonie",
    },
    {
      src: "https://player.vimeo.com/video/1022976377?badge=0&autopause=0&player_id=0&app_id=58479",
      thumbnail: "/img/portfolio/video-img/vimeo8_compression.jpg",
      title: "Dans l'atelier de Elzbieta Radziwill",
    },
    {
      src: "https://player.vimeo.com/video/1029607678",
      thumbnail: "/img/portfolio/video-img/vimeo9_compression.jpg",
      title: "Angèle - Nonante-Cinq Tour",
    },
    {
      src: "https://player.vimeo.com/video/1023930673",
      thumbnail: "/img/portfolio/video-img/vimeo10_compression.jpg",
      title: "MICROSOFT",
    },
    {
      src: "https://player.vimeo.com/video/884245855",
      thumbnail: "/img/portfolio/video-img/vimeo11_compression.jpg",
      title: "OGEE YouTube Live Performance",
    },
    {
      src: "https://player.vimeo.com/video/1028143548",
      thumbnail: "/img/portfolio/video-img/vimeo12_compression.jpg",
      title: "Portfolio Sacha Taieb",
    },
  ];

  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
  };

  const closeModal = () => {
    setSelectedVideo(null);
  };

  return (
    <>
      <section
        className="banner-header banner-img banner-img-top section-padding valign bg-img bg-fixed banner-overlay"
        data-overlay-darkgray="1"
        style={{
          backgroundImage:
            "url('/img/portfolio/video-img/vimeo4_compression.jpg')",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <h1>Galerie Vidéo</h1>
              <hr className="border-1 text-white" />
              <p>
                Découvrez nos réalisations vidéo, mettant en lumière des moments
                forts et des collaborations uniques à travers des projets
                inspirants.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding bg-blck">
        <div className="container">
          <div className="row">
            {videos.map((video, index) => (
              <div
                key={index}
                className="col-md-6"
                style={{ cursor: "pointer" }}
              >
                <div className="vid-area mb-30">
                  <div
                    className="vid-icon"
                    onClick={() => handleVideoClick(video)}
                  >
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="img-fluid"
                    />
                    <span className="video-gallery-button vid">
                      <span className="video-gallery-polygon">
                        <TiMediaPlay size={30} /> {/* Icône Play */}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedVideo && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <iframe
              src={selectedVideo.src}
              width="100%"
              height="500"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title={selectedVideo.title}
            ></iframe>
            <button className="modal-close" onClick={closeModal}>
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoGallery;
